import { React, useState } from "react";
import { Link } from "react-router-dom";
import Form from "../../component/utilities/Forms";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import * as CONST from "../../component/config/Constant";
import "../../assets/css/auth.css";
import { FiMail, FiArrowLeft } from "react-icons/fi";

export default function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [validate, setValidate] = useState({});
  const [loading, setloaing] = useState(false);

  const validateForgotPassword = async () => {
    let isValid = true;
    let validator = Form.validator({
      email: { value: email, isRequired: true, isEmail: true, label: "email" },
    });
    if (validator !== null) {
      setValidate({ validate: validator.errors });
      isValid = false;
    } else {
      setValidate({ validate: "" });
    }
    return isValid;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    const valid = await validateForgotPassword();
    if (valid) {
      setloaing(true);
      await axios.post(CONST.FORGOT_PASSWORD, { email, login_url: CONST.APP_LINK })
        .then((response) => {
          setloaing(false);
          if (response.data.status === "success") {
            toast.success("Password recovery email has been sent. Please check your email.");
          } else {
            toast.error(response.data.message);
          }
        })
        .catch(() => { setloaing(false); toast.error("There was an error."); });
    }
  };

  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <section className="auth-page">
        <div className="auth-page-inner">
          <div className="auth-form-panel">
            <div className="auth-form-wrapper">
              <Link to="/login" className="auth-back-link"><FiArrowLeft /> Back to Login</Link>
              <div className="auth-form-header">
                <h3 className="auth-form-title">Password Recovery</h3>
                <p className="auth-form-subtitle">Enter the email associated with your account</p>
              </div>

              <form className="auth-form" method="POST" onSubmit={submitForm} autoComplete="off">
                <div className="auth-input-group">
                  <label className="auth-label"><FiMail size={14} /> Email address</label>
                  <input
                    type="email"
                    className={`form-control auth-input ${validate.validate?.email ? "is-invalid" : ""}`}
                    value={email}
                    placeholder="your@email.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {validate.validate?.email && <div className="invalid-feedback d-block">{validate.validate.email[0]}</div>}
                </div>

                <button type="submit" className="btn auth-submit-btn">
                  <FiMail /> Send Recovery Email
                </button>
              </form>

              <div className="auth-alt-link">
                Remember your password? <Link to="/login"><strong>Sign in</strong></Link>
              </div>
            </div>
          </div>

          <div className="auth-brand-panel">
            <div className="auth-brand-content">
              <h2 className="auth-brand-title">Forgot Password?</h2>
              <p className="auth-brand-text">No worries! Enter your email and we'll send you instructions to reset your password.</p>
              <img className="auth-brand-illustration" src={process.env.PUBLIC_URL + "/assets/img/login/auth-illustration.svg"} alt="Forgot Password" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
